import { Children, isValidElement } from 'react';
const hasChildren = (element) => isValidElement(element) &&
    Boolean(element.props.children);
function childToString(child) {
    if (typeof child === 'undefined' ||
        child === null ||
        typeof child === 'boolean') {
        return;
    }
    if (JSON.stringify(child) === '{}') {
        return;
    }
    return child.toString();
}
export function onlyTextChildren(children) {
    if (!(children instanceof Array) && !isValidElement(children)) {
        return childToString(children);
    }
    return Children.toArray(children).reduce((text, child) => {
        let newText;
        if (isValidElement(child) && hasChildren(child)) {
            newText = onlyTextChildren(child.props.children);
        }
        else if (isValidElement(child) && !hasChildren(child)) {
            newText = undefined;
        }
        else {
            newText = childToString(child);
        }
        return newText ? (text || '').concat(newText) : text;
    }, undefined);
}
//# sourceMappingURL=onlyTextChildren.js.map